export const NewSupplierGetters = {
  NewSupplier: 'getNewSupplier'
};
